/* lua.js generated code 0.3.0 */

var GameGuideData = require("clover/gameGuide/GameGuideData")
var GameGuideCheck = {}
GameGuideCheck.verifyGuideConditions = function (guides) {
    var self = this
    var checkList = table()
    for (var k in guides) {
        var v = guides[k]
        checkList = table()
        if (type(v.appear) !== "table") {
            assert(false, "Illegal appear list! index: " + tostring(k))
            return 
        }
        if ($len(v.appear) <= 0) {
            assert(false, "Empty appear list! index: " + tostring(k))
            return 
        }
        for (let i = 1, v1 = v.appear[1]; v1; i++, v1 = v.appear[i]) {
            if (!v1.type) {
                assert(false, "Appear condition without type! index: " + tostring(k))
                return 
            }
            if (checkList[v1.type] === true) {
                assert(false, "Repeat appear condition in Guides! index: " + tostring(k))
                return 
            }
            if (type(self[v1.type]) !== "function") {
                assert(false, "Unsupported appear type by GameGuide! index/type: " + tostring(k) + "/" + tostring(v1.type))
                return 
            }
            checkList[v1.type] = true
        }
        checkList = table()
        if (type(v.disappear) !== "table") {
            assert(false, "Illegal disappear list! index: " + tostring(k))
            return 
        }
        for (var i = 1, v1 = v.disappear[1]; v1; i++, v1 = v.disappear[i]) {
            if (!v1.type) {
                assert(false, "Disappear condition without type! index: " + tostring(k))
                return 
            }
            if (checkList[v1.type] === true) {
                assert(false, "Repeat disappear condition in Guides! index: " + tostring(k))
                return 
            }
            if (type(self[v1.type]) !== "function") {
                assert(false, "Unsupported disappear type by GameGuide! index/type: " + tostring(k) + "/" + tostring(v1.type))
                return 
            }
            checkList[v1.type] = true
        }
    }
}
GameGuideCheck.checkAppear = function (guide, paras, index) {
    var self = this
    if (type(guide.appear) !== "table") {
        return false
    }
    for (var i = 1, v = guide.appear[1]; v; i++, v = guide.appear[i]) {
        if (type(self[v.type]) === "function") {
            if (!self[v.type](index, v, paras)) {
                return false
            }
        } else if (__WIN32) {
            assert(false, "Unsupported appear type by GameGuide! index/type: " + tostring(index) + "/" + tostring(v.type))
        }
    }
    return true
}
GameGuideCheck.checkDisappear = function (guide, paras, index) {
    var self = this
    if (type(guide.disappear) !== "table") {
        return [false]
    }
    for (var i = 1, v = guide.disappear[1]; v; i++, v = guide.disappear[i]) {
        if (type(self[v.type]) === "function") {
            var ok = self[v.type](index, v, paras)
            if (ok) {
                var rec = true
                if (type(v.rec) === "boolean") {
                    rec = v.rec
                }
                var success = true
                if (type(v.success) === "boolean") {
                    success = v.success
                }
                return [true, rec, success]
            }
        } else if (__WIN32) {
            assert(false, "Unsupported disappear type by GameGuide! index/type: " + tostring(index) + "/" + tostring(v.type))
        }
    }
    return [false]
}
GameGuideCheck.checkFixedAppears = function (guide, list, paras, index) {
    var self = this
    var checkList = table()
    for (var i = 1, v = list[1]; v; i++, v = list[i]) {
        checkList[v.type] = table(
            [1, "condition", v.condition],
            [1, "force", v.force],
            [1, "check", false]
        )
    }
    for (var i = 1, v = guide.appear[1]; v; i++, v = guide.appear[i]) {
        if (checkList[v.type]) {
            checkList[v.type].check = true
            if (type(self[v.type]) === "function") {
                if (!self[v.type](index, v, paras)) {
                    return false
                }
            } else if (__WIN32) {
                assert(false, "Unsupported disappear type by GameGuide! index/type: " + tostring(index) + "/" + v.type)
            }
        }
    }
    for (var k in checkList) {
        var v = checkList[k]
        if (!v.check && v.force) {
            return false
        }
    }
    return true
}
GameGuideCheck.buttonShow = function (index, condition, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (!data.containInGameFlags("buttonShow")) {
        return false
    }
    return condition.para != null && condition.para === (paras || table()).button
}

GameGuideCheck.secondSelctProp = function (index, condition, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (!data.containInGameFlags("secondSelectProp")) {
        return false
    }
    if (type(condition.propId) === "table") {
        return table.indexof(condition.propId, (paras || table()).propId) != null
    } else if (type(condition.propId) === "number") {
        return condition.propId === (paras || table()).propId
    } else {
        return true
    }
}

GameGuideCheck.cancelUseProp = function (index, condition, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (!data.containInGameFlags("cancelUseProp")) {
        return false
    }
    if (type(condition.propId) === "table") {
        return table.indexof(condition.propId, (paras || table()).propId) != null
    } else if (type(condition.propId) === "number") {
        return condition.propId === (paras || table()).propId
    } else {
        return true
    }
}

function CompG(a, b) {
    return a > b
}
function CompL(a, b) {
    return a < b
}
GameGuideCheck.guidedNum = function (index, condition, paras) {
    var self = this
    if (type(condition.target) === "table") {
        for (var i = 1, v = condition.target[1]; v; i++, v = condition.target[i]) {
            var func = (v.mode === "g") && CompG || CompL
            if (!func(GameGuideData.getInstance().countGuidedIndex(v.target), v.num)) {
                return false
            }
        }
        return true
    } else if (type(condition.target) === "number") {
        var func = (condition.mode === "g") && CompG || CompL
        // WARN: maybe multi result
        return func(GameGuideData.getInstance().countGuidedIndex(condition.target), condition.num)
    } else {
        var func = (condition.mode === "g") && CompG || CompL
        // WARN: maybe multi result
        return func(GameGuideData.getInstance().countGuidedIndex(index), condition.num)
    }
}

GameGuideCheck.confirmUseProp = function (index, condition, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (!data.containInGameFlags("confirmUseProp")) {
        return false
    }
    if (type(condition.propId) === "table") {
        return table.indexof(condition.propId, (paras || table()).propId) != null
    } else if (type(condition.propId) === "number") {
        return condition.propId === (paras || table()).propId
    } else {
        return true
    }
}
GameGuideCheck.curLevelGuided = function (index, condition, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    for (var k = 1, v = condition.guide[1]; v; k++, v = condition.guide[k]) {
        if (!data.containInCurLevelGuide(v)) {
            return false
        }
    }
    return true
}
GameGuideCheck.fishSpawn = function (index, condition, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (type(condition.num) === "number") {
        return data.containInGameFlags("fishSpawn") && data.getFishSpawnWave() <= condition.num
    } else {
        return data.containInGameFlags("fishSpawn") && data.getFishSpawnWave() !== 0
    }
}
GameGuideCheck.gameWaiting = function (index, condition, paras) {
    return GameGuideData.getInstance().getGameWaiting()
}
GameGuideCheck.guidedNumLessEqual = function (index, condition, paras) {
    return GameGuideData.getInstance().countGuidedIndex(index) < condition.num
}
GameGuideCheck.levelStage = function (index, condition, paras) {
    return GameGuideData.getInstance().getLevelStage() === condition.stage
}
GameGuideCheck.noPopup = function (index, condition, paras) {
    return GameGuideData.getInstance().getPopups() <= 0
}
GameGuideCheck.numMoves = function (index, condition, paras) {
    return GameGuideData.getInstance().getNumMoves() === condition.para
}
GameGuideCheck.onceLevel = function (index, condition, paras) {
    return !GameGuideData.getInstance().containInGuideInLevel(index)
}
GameGuideCheck.onceOnly = function (index, condition, paras) {
    return GameGuideData.getInstance().countGuidedIndex(index) <= 0
}
GameGuideCheck.openedStarGroup = function (index, condition, paras) {
    return false;
}
GameGuideCheck.popdown = function (index, condition, paras) {
    var self = this
    if (GameGuideData.getInstance().containInGameFlags("panelRise")) {
        return;
    }
    var actWinName = (((paras || table()).panel || table()).class || table()).__cname
    if (type(condition.panel) === "table") {
        if (!table.indexof(condition.panel, actWinName)) {
            return false
        }
    } else if (type(condition.panel) === "string") {
        if (condition.panel !== actWinName) {
            return false
        }
    }
    return true
}
GameGuideCheck.popup = function (index, condition, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (data.getPopups() === 0 || !paras || !paras.panel) {
        return false
    }
    var actWinName = ((paras.panel || table()).class || table()).__cname
    if (type(condition.panel) === "table") {
        if (!table.indexof(condition.panel, actWinName)) {
            return false
        }
    } else if (type(condition.panel) === "string") {
        if (condition.panel !== actWinName) {
            return false
        }
    }
    if (type(condition.para) === "table") {
        return table.indexof(condition.para, paras.panel.levelId) !== false
    } else if (type(condition.para) === "number") {
        return condition.para === paras.panel.levelId
    }
    return true
}
GameGuideCheck.replay = function (index, condition, paras) {
    // WARN: maybe multi result
    return GameGuideData.getInstance().containInGameFlags("replay", true)
}
GameGuideCheck.scene = function (index, condition, paras) {
    var data = GameGuideData.getInstance()
    if (condition.scene !== data.getScene()) {
        return false
    }
    if (condition.scene === "GameScene") {
        if (type(condition.level) === "number" && condition.level !== data.getLevelId()) {
            return false
        }
        if (type(condition.level) === "table" && !table.exist(condition.level, data.getLevelId())) {
            return false
        }
    }
    return true
}
GameGuideCheck.selectProp = function (index, condition, paras) {
    if (!GameGuideData.getInstance().containInGameFlags("selectProp")) {
        return false
    }
    if (type(condition.propId) !== "number") {
        return true
    }
    return condition.propId === (paras || table()).propId
}
GameGuideCheck.starCount = function (index, condition, paras) {
    var user = UserManager.getInstance().getUserRef()
    if (type(condition.star) === "number" && user.getTotalStar() < condition.star) {
        return false
    }
    if (type(condition.yellowStar) === "number" && user.getYellowStar() < condition.yellowStar) {
        return false
    }
    if (type(condition.orangeStar) === "number" && user.getOrangeStar() < condition.orangeStar) {
        return false
    }
    if (type(condition.blueStar) === "number" && user.getBlueStar() < condition.blueStar) {
        return false
    }
    return true
}
GameGuideCheck.starGroupReward = function (index, condition, paras) {
    return false
}
GameGuideCheck.swap = function (index, condition, paras) {
    if (!GameGuideData.getInstance().containInGameFlags("gameSwap") || type(paras) !== "table") {
        return false
    }
    if (!condition.from || !condition.to) {
        return true
    }
    if (type(paras.from) !== "table" || type(paras.from.x) !== "number" || type(paras.from.y) !== "number" || type(paras.to) !== "table" || type(paras.to.x) !== "number" || type(paras.to.y) !== "number") {
        return false
    }
    return (paras.from.x === condition.from.x && paras.from.y === condition.from.y && paras.to.x === condition.to.x && paras.to.y === condition.to.y) || (paras.to.x === condition.from.x && paras.to.y === condition.from.y && paras.from.x === condition.to.x && paras.from.y === condition.to.y)
}
GameGuideCheck.succeedNum = function (index, condition, paras) {
    var self = this
    if (type(condition.target) === "table") {
        for (var i = 1, v = condition.target[1]; v; i++, v = condition.target[i]) {
            var func = (v.mode === "g") && CompG || CompL
            if (!func(GameGuideData.getInstance().countSucceedGuideIndex(v.target), v.num)) {
                return false
            }
        }
        return true
    } else if (type(condition.target) === "number") {
        var func = (condition.mode === "g") && CompG || CompL
        // WARN: maybe multi result
        return func(GameGuideData.getInstance().countSucceedGuideIndex(condition.target), condition.num)
    } else {
        var func = (condition.mode === "g") && CompG || CompL
        // WARN: maybe multi result
        return func(GameGuideData.getInstance().countSucceedGuideIndex(index), condition.num)
    }
}

GameGuideCheck.topLevel = function (index, condition, paras) {
    if (type(condition.para) === "table") {
        return table.indexof(condition.para, UserManager.getInstance().getUserRef().getTopLevelId()) !== false
    } else {
        return UserManager.getInstance().getUserRef().getTopLevelId() === condition.para
    }
}

GameGuideCheck.weekGameOpened = function (index, condition, paras) {
    return false;
}
GameGuideCheck.weekGameTargetZero = function (index, condition, paras) {
    return true;
}
GameGuideCheck.gameplayFlag = function (index, condition, paras) {
    var self = this
    // WARN: maybe multi result
    return GameGuideData.getInstance().containInGameplayFlags(condition.flag)
}
GameGuideCheck.negotiatorLevel = function (index, condition, paras) {
    let self = this
    if (window.NegotiatorManager && condition && condition.level) {
        return condition.level === window.NegotiatorManager.getInstance().getTopLevelInStage()
    }
    return false
}
GameGuideCheck.useEnergyBottle = function (index, condition, paras) {
    let self = this
    if (paras && paras.panel) {
        let actWinName = ((paras.panel || table()).class || table()).__cname
        if (actWinName === "StartPanel" && paras.panel.recoverNum > 0) {
            return true
        }
    }
    return false
}
GameGuideCheck.animalCoinShow = function (index, condition, paras) {
    let self = this
    // WARN: maybe multi result
    return GameGuideData.getInstance().containInGameFlags(condition.type)
}
GameGuideCheck.scoreAnimalBuff = function (index, condition, paras) {
    let self = this
    // WARN: maybe multi result
    return GameGuideData.getInstance().containInGameFlags(condition.type)
}
GameGuideCheck.propBlock = function (index, condition, paras) {
    let self = this
    // WARN: maybe multi result
    return GameGuideData.getInstance().containInGameFlags(condition.type)
}
GameGuideCheck.gamePlayType = function (index, condition, paras) {
    let self = this
    let scene = cc.Director.getInstance().getRunningScene()
    if (!scene || scene.name !== "GameScene") {
        return false
    }
    if (scene.logic) {
        for (let k = 1, v = condition.para[1]; v; k++, v = condition.para[k]) {
            if (scene.logic.theGamePlayType === GamePlayType[v]) {
                return true
            }
        }
    }
    return false
}
GameGuideCheck.maintenance = function (index, condition, paras) {
    let self = this
    let xdefault = false
    if (condition.default != null) {
        xdefault = condition.default
    }
    let uid = null
    if (condition.uid) {
        uid = tostring(UserManager.getInstance().uid)
    }
    // WARN: maybe multi result
    return MaintenanceManager.getInstance().isEnabled(condition.key, xdefault, uid)
}
GameGuideCheck.onLifeBuff = function (index, condition, paras) {
    let self = this
    let levelId = GameGuideData.getInstance().getLevelId()
    // if (ActivityPropManager) {
    //     let flag = ActivityPropManager.getInstance().getOneLifeRewardFlag(levelId)
    //     return flag < 1
    // }
    return true
}
GameGuideCheck.swapMergeSpecialNum = function (index, condition, paras) {
    let self = this
    // body
    let mergeNum = GamePlayCacheManager.getInstance().getSwapMergeNum()
    if (condition.gt && mergeNum < condition.gt) {
        return false
    }
    if (condition.lt && mergeNum > condition.lt) {
        return false
    }
    return true
}

GameGuideCheck.fourTileLowAction = function (index, condition, paras) {
    let self = this
    // body
    let levelId = GameGuideData.getInstance().getLevelId()
    let result = GamePlayCacheManager.getInstance().isNeedLowLevelAdviceFourTile(levelId)
    return result
}
module.exports = GameGuideCheck
